import { EUserRole } from '../constants/user'

export const RoleUserOptions = {
  [EUserRole.USER]: {
    id: EUserRole.USER,
    level: 0,
    value: [EUserRole.USER],
  },
  [EUserRole.MERCHANT]: {
    id: EUserRole.MERCHANT,
    level: 1,
    value: [EUserRole.USER, EUserRole.MERCHANT],
  },
  [EUserRole.ADMIN]: {
    id: EUserRole.ADMIN,
    level: 2,
    value: [EUserRole.USER, EUserRole.MERCHANT, EUserRole.ADMIN],
  },
  [EUserRole.SUPER_ADMIN]: {
    id: EUserRole.SUPER_ADMIN,
    level: 3,
    value: [
      EUserRole.USER,
      EUserRole.MERCHANT,
      EUserRole.ADMIN,
      EUserRole.SUPER_ADMIN,
    ],
  },
}

export const isRoleMerchant = (roles: string[]) => {
  // return false
  return roles.includes(EUserRole.MERCHANT) || roles.includes(EUserRole.ADMIN)
}

const getRoleUser = (roles: string[]) => {
  let role
  if (roles.includes(EUserRole.SUPER_ADMIN)) {
    role = {
      role: EUserRole.SUPER_ADMIN,
      level: RoleUserOptions[EUserRole.SUPER_ADMIN].level,
    }
  } else if (roles.includes(EUserRole.ADMIN)) {
    role = {
      role: EUserRole.ADMIN,
      level: RoleUserOptions[EUserRole.ADMIN].level,
    }
  } else if (roles.includes(EUserRole.MERCHANT)) {
    role = {
      role: EUserRole.MERCHANT,
      level: RoleUserOptions[EUserRole.MERCHANT].level,
    }
  } else {
    role = {
      role: EUserRole.USER,
      level: RoleUserOptions[EUserRole.USER].level,
    }
  }

  return role
}

export default getRoleUser
